module.exports = __webpack_public_path__ + "img/2021-min.da4b5a48.jpg";